import React, { useEffect } from "react";
import { connect } from "react-redux";
import { allActorsResults } from "../../services/api";

import Label from "../Labels/Label";
import NotesCardList from "./NotesCardList";
import NotesChartLine from "./NotesChartLine";
import NotesChartBar from "./NotesChartBar";

import "./Charts.css";

const NoteChartView = ({ usuarioId, actorsResults }) => {
    const effectAsync = async () => {
        await allActorsResults();
    };

    useEffect(() => {
        effectAsync();
    }, []);

    return (
        <div className="row mb-4">
            <div className="col-md-12 mb-2 home_chart_container home_card_list_container">
                <Label text="ESTAÇÕES CONDUZIDAS PELO ATOR" />

                <NotesCardList
                    usuarioId={usuarioId}
                    actorsResults={actorsResults}
                />
            </div>

            <div className="col-md-12 mb-4 home_chart_container">
                <Label text="DESEMPENHO E RESULTADOS" />

                <NotesChartLine
                    usuarioId={usuarioId}
                    actorsResults={actorsResults}
                />
            </div>

            <div className="col-md-12 mt-4 home_chart_container">
                <Label text="DESEMPENHO E RESULTADOS" />

                <NotesChartBar
                    usuarioId={usuarioId}
                    actorsResults={actorsResults}
                />
            </div>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(NoteChartView);